import { useState, useEffect } from "react";
import MatchDetailsForm from "./MatchDetailsForm.jsx";
import MatchStarted from "./MatchStarted.jsx";
import MatchEnded from "./MatchEnded.jsx"
import { LongDateFormat } from '../utils/date_format.js'
import MatchGuessStatus from './match-guess-statuses/MatchGuessStatus.jsx'
import MatchDetailsStatus from './match-details-statuses/MatchDetailsStatus.jsx'
import { GetMatchResult } from "../repo/MatchesRepo.js";

export default function MatchesDetails({groupId, match, bet}) {
  const [currentMatch, setCurrentMatch] = useState(match)
  const [statusLabel, setStatusLabel] = useState("")
  const [responseError, setResponseError] = useState("")

  const hasMatchStarted = currentMatch.is_started
  const hasMatchEnded = currentMatch.is_ended

  useEffect(() => {
    setCurrentMatch(match)
  }, [match])

  useEffect(() => {
    if (!(hasMatchStarted && !hasMatchEnded)) return

    const pollMatch = async () => {
      try {
        const result = await GetMatchResult(currentMatch.id)
        const newData = result?.data
        if (!newData) return

        setCurrentMatch(prev => {
          if (
            newData.is_started === prev.is_started &&
            newData.is_ended === prev.is_ended &&
            newData.team_a_score === prev.team_a_score &&
            newData.team_b_score === prev.team_b_score
          ) {
            return prev
          }

          return {
            ...prev,
            is_started: newData.is_started,
            is_ended: newData.is_ended,
            team_a_score: newData.team_a_score,
            team_b_score: newData.team_b_score,
          }
        })
      } catch (error) {
        console.error('Error polling match result:', error)
      }
    }

    const intervalId = setInterval(pollMatch, 60000)
    return () => clearInterval(intervalId)
  }, [hasMatchStarted, hasMatchEnded, currentMatch.id])

  const handleGuessingStatus = (newStatus) => {
    switch (newStatus) {
      case "Saving":
        setStatusLabel("Salvando");
        break;
      case "Saved":
        setStatusLabel("Salvo");
        break;
      case "Error":
        setStatusLabel("Erro");
        break;
      case "Warning":
        setStatusLabel("Aviso");
        break;
      default:
        setStatusLabel("");
    }
  }

  const handleResponseError = (message) => {
    setResponseError(message)
  }

  const reponseErrorColor = () => {
    switch (statusLabel) {
      case "Aviso":
        return "yellow-500"
      case "Erro":
        return "red-500"
      default:
        return "slate-300"
    }
  }

  return (
    <div key={"div-" + groupId + "|" + currentMatch.id} id={groupId + "|" + currentMatch.id} className={`relative flex flex-col mb-4 mx-4 bg-white border rounded-lg lg:min-w-[600px] border-${reponseErrorColor()}`}>
      <div className="text-center pt-2 pb-4 text-sm">
        <span className="font-semibold">{currentMatch.phase}</span><br/>
        <span className="text-xs">{LongDateFormat(currentMatch.starts_at)}</span>
      </div>
      {hasMatchStarted && !hasMatchEnded &&
        <MatchStarted match={currentMatch} bet={bet} />
      }
      {hasMatchStarted && hasMatchEnded &&
        <MatchEnded match={currentMatch} bet={bet} groupId={groupId} />
      }
      {!hasMatchStarted &&
        <MatchDetailsForm
          groupId={groupId}
          match={currentMatch}
          bet={bet}
          handleGuessingStatus={handleGuessingStatus}
          handleResponseError={handleResponseError}
        />
      }

      {!hasMatchStarted ?
        <MatchGuessStatus status={statusLabel} />
      :
        <MatchDetailsStatus groupId={groupId} match={currentMatch} bet={bet} hasMatchEnded={hasMatchEnded} />
      }

      {responseError !== "" &&
        <div className={`text-center w-full bg-${reponseErrorColor()} border-${reponseErrorColor()} rounded-b-lg text-white`}>
          {responseError}
        </div>
      }
    </div>
  )
}
